module.exports = __webpack_public_path__ + "static/media/trimex_lidia.3e478368.png";